import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class CondicionPago extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'condicion-pago/one', saveUrl: 'condicion-pago/save', backUrl: '/Catalogo/CondicionesPagos' },
      new Form([
        Form.Field('text', 'condicion', 'Plazo', '', [Validators.required], 4),
        Form.Field('text', 'condicion_nombre', 'Descripcion', '', [Validators.required], 8),
      ], ['Guardar'], 'Condicion de Pago'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CondicionPago)
